import type { Schema, SchemaField } from '@cli-types/core-engine/schema.js'
import { flattenFields } from '@core-engine/schema/field-helpers/flattening/flatten-fields.js'
import { isLayoutField } from '@core-engine/schema/field-type-guards/is-layout-field.js'

export function getCreatableSelectFields(schema: Schema): SchemaField[] {
  return flattenFields(schema.fields).filter(
    (field) => field.type === 'select' && field.creatable === true && !isLayoutField(field.type)
  )
}
